import WithdrawalPasswordGate from './WithdrawalPasswordGate.vue'

// First-time setup is separate from bank details. Never persist a plaintext password.
export default {
  components: { WithdrawalPasswordGate },
  data() {
    return { passwordSetupOpen: false, passwordStatusLoading: false, passwordContinuation: null, passwordCancellation: null }
  },
  methods: {
    async ensureWithdrawalPassword(continuation, cancellation, checkWithdrawal = false) {
      if (this.passwordStatusLoading || this.passwordSetupOpen) return
      this.passwordStatusLoading = true
      try {
        const res = await this.$http({ method: 'get', url: 'user_info' })
        if (!res || res.code !== 200) {
          this.$toast((res && res.msg) || '暫時無法取得帳戶資料，請重試')
          return
        }
        if (checkWithdrawal && Number(res.data.withdraw_disabled) === 1) {
          this.$toast('已凍結，請聯絡客服')
          return
        }
        if (res.data.has_paypassword) return continuation()
        this.passwordContinuation = continuation
        this.passwordCancellation = cancellation || null
        this.passwordSetupOpen = true
      } catch (error) { this.$toast('連線失敗，請稍後重試') }
      finally { this.passwordStatusLoading = false }
    },
    finishPasswordSetup() {
      const next = this.passwordContinuation
      this.passwordContinuation = null
      this.passwordCancellation = null
      this.passwordSetupOpen = false
      if (next) next()
    },
    cancelPasswordSetup() {
      const cancel = this.passwordCancellation
      this.passwordContinuation = null
      this.passwordCancellation = null
      if (cancel) cancel()
    },
  },
}
